// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"12e88488","179":"5fb5f538","228":"ef8fa907","272":"8ec62dfe","352":"99f7989f","549":"5bceb1d0","666":"b2c655b9","816":"c2299ba0","930":"0b18930c","996":"0e88fe7f"}[chunkId] + ".chunk.js";
};